// Site-level SEO constants. Domain intentionally hard-coded to the canonical
// production host so absolute URLs (canonical, og:url, JSON-LD) point there
// regardless of which preview subdomain the app is served from.
export const SITE_URL = "https://refinetouchusa.com";
export const SITE_NAME = "Refine Touch USA";
export const DEFAULT_TITLE = "Refine Touch USA | Connecting U.S. Clients with French Experts";
export const DEFAULT_DESCRIPTION =
  "Refine Touch USA connects American clients with trusted independent French professionals — private chefs, language tutors, designers, real estate experts and more. Discover exceptional French talent in the USA.";
export const OG_IMAGE = `${SITE_URL}/brand/refine-touch-logo.jpg`;

export const abs = (path = "/") => {
  const p = String(path).startsWith("/") ? path : `/${path}`;
  return `${SITE_URL}${p}`;
};

export const orgJsonLd = () => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  name: SITE_NAME,
  url: `${SITE_URL}/`,
  logo: OG_IMAGE,
  sameAs: [],
});

export const websiteJsonLd = () => ({
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: SITE_NAME,
  url: `${SITE_URL}/`,
  potentialAction: {
    "@type": "SearchAction",
    target: `${SITE_URL}/services?search={search_term_string}`,
    "query-input": "required name=search_term_string",
  },
});

export const breadcrumbJsonLd = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: it.item,
  })),
});
